<template>
  <div id="app">
    <!-- <router-view></router-view> -->


     <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

   <Footer></Footer> 
  </div>
</template>  

<script>
import Footer from "./components/footer/footer";
export default {
   components: {
    Footer
  },
  name: "App",
};
//防止页面双击放大，双指放大
window.onload = function() {
  // // 禁用缩放
  // function addMeta() {
  //   $('head').append('<meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no" />');
  // }
  // setTimeout(addMeta, 3000);

  // 禁用双指放大
  document.documentElement.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }, {
    passive: false
  });
  // 禁用双击放大
  var lastTouchEnd = 0;
  document.documentElement.addEventListener('touchend', function(event) {
    var now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, {
    passive: false
  });
}
</script>

<style>
  body{
    font-size: 16px;
    background-color: #f8f8f8;
    -webkit-font-smoothing: antialiased;
  }
</style>

